/**
 * Validation Message Component
 *
 * A simple component for displaying form validation error messages.
 * It provides consistent styling for error messages throughout the application.
 *
 * Features:
 * - Customizable height
 * - Consistent text color and spacing
 * - Clean integration with form fields
 *
 * @module components/validation-message/validation-message
 */

import styled from "styled-components";

/**
 * Styled error message container with customizable height
 */
const Message = styled.div`
  height: ${({ $height }) => `${$height}px`};
`;

/**
 * Component that displays a validation error message
 *
 * @param {Object} props - Component properties
 * @param {string} props.error - The error message to display
 * @param {string} [props.height="auto"] - Custom height for the message container
 * @returns {JSX.Element} Validation message component
 */
const ValidationMessage = ({ error, height = "auto" }) => {
  return (
    <Message $height={height} className="text-danger pt-1">
      {error}
    </Message>
  );
};

export default ValidationMessage;
